"use client";

import { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  function isValidEmail(e) {
    return /\S+@\S+\.\S+/.test(e);
  }

  async function handleSubmit(ev) {
    ev.preventDefault();
    if (!isValidEmail(email)) {
      setStatus("error");
      return;
    }

    setStatus("sending");

    try {
      await new Promise((r) => setTimeout(r, 600));
      setStatus("success");
      setEmail("");
    } catch (err) {
      setStatus("error");
    }
  }

 return (
<section className="py-16 bg-newblue/10" id="newsletter">
<div className="container mx-auto px-4 md:px-6">
<div className="flex flex-col items-center text-center max-w-md mx-auto">
<form
onSubmit={handleSubmit}
className="max-w-md w-full bg-white p-6 rounded-lg shadow-lg border text-center"
aria-live="polite"
>
<h2 className="text-2xl font-semibold text-gray-800 mb-4">
Join Our Newsletter!
</h2>


<div className="flex flex-col sm:flex-row items-stretch gap-2 sm:gap-0">
<input
id="signup-email"
type="email"
inputMode="email"
placeholder="you@example.com"
value={email}
onChange={(e) => {
setEmail(e.target.value);
if (status !== "idle") setStatus("idle");
}}
className="flex-1 px-3 py-2 border-2 rounded-md sm:rounded-l-md sm:rounded-r-none focus:outline-none focus:ring-2 text-sm"
aria-invalid={status === "error"}
aria-describedby="signup-help"
/>


<button
type="submit"
className="px-5 py-2.5 bg-blue-600/90 hover:bg-blue-900 text-white font-medium text-sm rounded-md sm:rounded-r-md sm:rounded-l-none focus:ring-2 transition disabled:opacity-60 w-full sm:w-auto"
disabled={status === "sending"}
>
{status === "sending" ? "Signing up..." : "Sign Up"}
</button>
</div>


<p id="signup-help" className="mt-3 text-sm h-5">
{status === "error" && (
<span className="text-red-600">
Please enter a valid email.
</span>
)}
{status === "success" && (
<span className="text-green-600">
Thanks — you’re signed up!
</span>
)}
</p>
</form>
</div>
</div>
</section>
);
}